import React, { createContext, useContext, useState } from "react";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
	const [showError, setShowError] = useState(false);
	const [error, setError] = useState("");

	const displayError = (errorMessage) => {
		setError(errorMessage);
		setShowError(true);
	};

	const clearError = () => {
		setError("");
		setShowError(false);
	};

	return (
		<ErrorContext.Provider
			value={{ showError, error, displayError, clearError }}>
			{children}
		</ErrorContext.Provider>
	);
};

export const useError = () => {
	const context = useContext(ErrorContext);
	if (context === undefined) {
		throw new Error("useError must be used within an ErrorProvider");
	}
	return context;
};
